import GeoService from './service/GeoService';
import GeoLocation from './model/GeoLocation';

class FasterGeo {
  private geoService: GeoService;

  public constructor(geoService: GeoService) {
    this.geoService = geoService;
  }

  public async getLocation(): Promise<GeoLocation> {
    return this.geoService.getLocation();
  }
}

export default FasterGeo;
